"use client";

import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import { Bell } from "lucide-react";
import { Pill } from "@/components/primitives/pill";
import { MOCK_ATTENTION_ITEMS } from "@/lib/mock-data";

/** Global Shell primitive: notification / action center. */
export function NotificationCenter() {
  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger asChild>
        <button
          type="button"
          aria-label={`Notifications, ${MOCK_ATTENTION_ITEMS.length} unread`}
          className="relative flex h-10 w-10 items-center justify-center rounded-control border border-border-subtle bg-surface-primary text-text-secondary shadow-[var(--shadow-subtle)] hover:bg-surface-secondary"
        >
          <Bell aria-hidden="true" size={16} />
          <span className="absolute -end-1 -top-1 flex h-4 min-w-4 items-center justify-center rounded-pill bg-status-danger px-1 text-[9px] font-bold text-white">
            {MOCK_ATTENTION_ITEMS.length}
          </span>
        </button>
      </DropdownMenu.Trigger>
      <DropdownMenu.Portal>
        <DropdownMenu.Content
          align="end"
          sideOffset={8}
          className="z-50 w-80 rounded-card border border-border-subtle bg-surface-elevated p-2 shadow-[var(--shadow-lifted)]"
        >
          <div className="flex items-center justify-between px-2 py-1.5">
            <p className="text-xs font-bold text-text-primary">Needs attention</p>
            <Pill tone="warning">{MOCK_ATTENTION_ITEMS.length} items</Pill>
          </div>
          {MOCK_ATTENTION_ITEMS.map((item) => (
            <DropdownMenu.Item
              key={item.id}
              className="cursor-pointer rounded-control px-2.5 py-2 text-start outline-none data-[highlighted]:bg-surface-secondary"
            >
              <p className="text-xs font-bold text-text-primary">{item.title}</p>
              <p className="mt-0.5 text-[11px] text-text-secondary">{item.description}</p>
            </DropdownMenu.Item>
          ))}
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
}
